import React from "react";
import { Navigate } from "react-router-dom";

function Protected({ children }) {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user && user?.role !== "user") {
    return <Navigate to="/dashboard/appointments" replace />;
  }

  return children;
}

export default Protected;
